import type { PublicBundle } from '../graphql/public'
import { formatEuro } from '../lib/catalog'

// The one static explainer on the wall (build-guide §2, chrome copy). Steps 2 and 3
// are DB text: the variant names of the main list and the bundle's own name,
// description and surcharge. A step whose data is missing is simply not drawn —
// nothing here is invented in code.

function StepCircle({ n }: { n: number }) {
  return (
    <span className="inline-flex items-center justify-center w-[48px] h-[48px] rounded-full bg-brand-jasper text-white font-secondary font-bold text-[26px] leading-none">
      {n}
    </span>
  )
}

export function HowItWorks({ sizes, bundle }: { sizes: string[]; bundle: PublicBundle | null }) {
  const bundleProduct = bundle ? bundle.bundle_product : null
  const bundleVariant = bundleProduct && bundleProduct.variants ? bundleProduct.variants[0] : null
  return (
    <div className="flex flex-col space-y-[12px] mt-[16px] px-[28px] py-[14px] bg-white border-2 border-brand-line rounded-[24px]">
      <div className="flex items-center space-x-[48px]">
        <div className="flex items-center space-x-[14px]">
          <StepCircle n={1} />
          <span className="font-secondary font-normal text-[32px] leading-[1.2] text-secondary-800">
            Pick your curry
          </span>
        </div>
        {sizes.length > 1 ? (
          <div className="flex items-center space-x-[14px]">
            <StepCircle n={2} />
            <span className="font-secondary font-normal text-[32px] leading-[1.2] text-secondary-800">
              {'Choose ' + sizes.join(' or ')}
            </span>
          </div>
        ) : null}
      </div>
      {bundleProduct ? (
        <div className="flex items-center space-x-[14px]">
          <StepCircle n={3} />
          <span className="font-primary font-bold text-[36px] leading-none text-brand-jasper">
            {bundleProduct.name}
          </span>
          {bundleProduct.description ? (
            <span className="font-secondary font-normal text-[32px] leading-[1.2] text-secondary-800">
              {bundleProduct.description}
            </span>
          ) : null}
          {bundleVariant ? (
            <span className="font-primary font-bold text-[36px] leading-none text-brand-jasper whitespace-nowrap">
              {'+ ' + formatEuro(bundleVariant.price_cents)}
            </span>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
